export const NoAccessToLLM =
  "You don't have any access to any language model. Please contact administrator";
